
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/workspace/[workspaceId]",
      function () {
        return require("private-next-pages/[tenantId]/workspace/[workspaceId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/workspace/[workspaceId]"])
      });
    }
  